export enum SubscriptionContainerEnum {
  ChangeSummaryView,
  ModifySubscriptionView,
  NewSubscriptionView,
  PaymentView,
  SubscriptionAgreementView,
  SubscriptionListView,
  SubscriptionRenewed,
}
